<script>
import CommonDetail from '@/views/Information/CommonDetail'
import api from '@/utils/api/operation'
export default {
  name: 'PoliciesDetail',
  extends: CommonDetail,
  data() {
    return {}
  },
  methods: {
    onload() {
      let params = {
        id: this.rid
      }
      api.getPoliciesDetail(params).then(res => {
        let data = res.data
        this.title = data.BT
        this.date = data.FBSJ
        this.content = data.ZCFG
        if (data.FJ) {
          let file = data.FJ.split('::')
          for (let i = 0; i < file.length; i++) {
            this.fileList.push(this.handleFile(file[i]))
          }
        }
      })
    },
    handleFile(val) {
      const pic = val.split('|')
      const macroPath = encodeURI(pic[1])
      const fileName = pic[0]
      let url =
        '/sinfoweb/onlineServiceProject/public/downFileByPath?macroPath=' +
        macroPath +
        '&fileName=' +
        fileName
      let params = {
        name: fileName,
        url: window.location.host + url
      }

      return params
    }
  }
}
</script>
